import React, { useEffect, useState } from 'react';
import { Form, Input, Link, Table } from 'tdesign-react';
import { useMemoizedFn } from 'ahooks';
import styled from 'styled-components';
import { EditIcon } from 'tdesign-icons-react';
import useTable from '@/hooks/useTable';
import { getConfigList } from '@/services/kafkaBrokerService';
import HideReadOnlyAppend from '@/components/Cluster/Configuration/HideReadOnlyAppend';
import { sleep } from '@/utils/common';
import SvgIcon from '@/components/SvgIcon';
import ConfigModal from './ConfigModal';

const { FormItem } = Form;

export default function Configuration({ clusterName, brokerId }) {
  const [visible, setVisible] = useState(false);
  const [currentRow, setCurrentRow] = useState({});
  const [hideReadOnlyConfig, setHideReadOnlyConfig] = useState(false);

  const columns = [
    {
      colKey: 'configItem',
      title: '配置名',
      width: 260,
      cell: ({ row }) => (
        <span>
          {row.configItem}
          {row.readOnlyConfig && (
            <SvgIcon
              type='lock-closed'
              color='var(--td-brand-color-7)'
              style={{ marginBottom: 3, marginLeft: 3 }}
            />
          )}
        </span>
      ),
      fixed: 'left',
    },
    {
      colKey: 'configExplanation',
      title: '描述',
    },
    {
      colKey: 'configValue',
      title: '配置值',
      width: 200,
    },
    {
      colKey: 'option',
      title: '操作',
      fixed: 'right',
      align: 'center',
      cell: ({ row }) =>
        row.readOnlyConfig ? null : (
          <Link
            theme='primary'
            hover='color'
            onClick={() => {
              setVisible(true);
              setCurrentRow(row);
            }}
          >
            <EditIcon />
          </Link>
        ),
      width: 60,
    },
  ];

  const onHideReadOnlyConfig = async (val) => {
    setHideReadOnlyConfig(val);
    await sleep(30);
    doSearch(null, true);
  };

  const loadData = useMemoizedFn(async (params = {}) => {
    const { data } = await getConfigList({
      ...params,
      clusterName,
      brokerId,
    });

    setData(
      data.filter((item) => {
        if (hideReadOnlyConfig) {
          return item.readOnlyConfig === false;
        }
        return item;
      }),
    );
  });
  const { config, header, setData, doSearch, doRefresh } = useTable({
    columns,
    onSearch: loadData,
    append: <HideReadOnlyAppend value={hideReadOnlyConfig} onChange={onHideReadOnlyConfig} />,
    search: (
      <>
        <FormItem name='configItem'>
          <Input placeholder='请输入配置名' clearable />
        </FormItem>
      </>
    ),
  });

  useEffect(() => {
    doSearch();
  }, [doSearch]);

  const handleClose = (refresh) => {
    setVisible(false);
    setCurrentRow({});
    if (refresh) {
      doRefresh();
    }
  };

  return (
    <Root>
      {header}
      <Table {...config} />
      <ConfigModal
        visible={visible}
        detail={currentRow}
        onClose={handleClose}
        brokerId={brokerId}
        clusterName={clusterName}
      />
    </Root>
  );
}

const Root = styled.div`
  padding-top: 18px;
`;
